export default {
  account: require('./account').default,
  mall: require('./mall').default,
  logistics: require('./logistics').default,
  views: require('./views').default,
  shopReward: require('./shopReward').default,
  bmap: require('./bmap').default,
};
